module.exports = __webpack_public_path__ + "img/Group26.c27c8ab1.png";